import { css } from 'styled-components';

// Roboto Light
import RobotoLightCyrillicExt from '../assets/fonts/KFOlCnqEu92Fr1MmSU5fCRc4AMP6lbBP.woff2';
import RobotoLightCyrillic from '../assets/fonts/KFOlCnqEu92Fr1MmSU5fABc4AMP6lbBP.woff2';
import RobotoLightGreekExt from '../assets/fonts/KFOlCnqEu92Fr1MmSU5fCBc4AMP6lbBP.woff2';
import RobotoLightGreek from '../assets/fonts/KFOlCnqEu92Fr1MmSU5fBxc4AMP6lbBP.woff2';
import RobotoLightVietnamese from '../assets/fonts/KFOlCnqEu92Fr1MmSU5fCxc4AMP6lbBP.woff2';
import RobotoLightLatinExt from '../assets/fonts/KFOlCnqEu92Fr1MmSU5fChc4AMP6lbBP.woff2';
import RobotoLightLatin from '../assets/fonts/KFOlCnqEu92Fr1MmSU5fBBc4AMP6lQ.woff2';

// Roboto Regular
import RobotoRegularCyrillicExt from '../assets/fonts/KFOmCnqEu92Fr1Mu72xKKTU1Kvnz.woff2';
import RobotoRegularCyrillic from '../assets/fonts/KFOmCnqEu92Fr1Mu5mxKKTU1Kvnz.woff2';
import RobotoRegularGreekExt from '../assets/fonts/KFOmCnqEu92Fr1Mu7mxKKTU1Kvnz.woff2';
import RobotoRegularGreek from '../assets/fonts/KFOmCnqEu92Fr1Mu4WxKKTU1Kvnz.woff2';
import RobotoRegularVietnamese from '../assets/fonts/KFOmCnqEu92Fr1Mu7WxKKTU1Kvnz.woff2';
import RobotoRegularLatinExt from '../assets/fonts/KFOmCnqEu92Fr1Mu7GxKKTU1Kvnz.woff2';
import RobotoRegularLatin from '../assets/fonts/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2';

// Roboto Medium
import RobotoMediumCyrillicExt from '../assets/fonts/KFOlCnqEu92Fr1MmEU9fCRc4AMP6lbBP.woff2';
import RobotoMediumCyrillic from '../assets/fonts/KFOlCnqEu92Fr1MmEU9fABc4AMP6lbBP.woff2';
import RobotoMediumGreekExt from '../assets/fonts/KFOlCnqEu92Fr1MmEU9fCBc4AMP6lbBP.woff2';
import RobotoMediumGreek from '../assets/fonts/KFOlCnqEu92Fr1MmEU9fBxc4AMP6lbBP.woff2';
import RobotoMediumVietnamese from '../assets/fonts/KFOlCnqEu92Fr1MmEU9fCxc4AMP6lbBP.woff2';
import RobotoMediumLatinExt from '../assets/fonts/KFOlCnqEu92Fr1MmEU9fChc4AMP6lbBP.woff2';
import RobotoMediumLatin from '../assets/fonts/KFOlCnqEu92Fr1MmEU9fBBc4AMP6lQ.woff2';

// Roboto Bold
import RobotoBoldCyrillicExt from '../assets/fonts/KFOlCnqEu92Fr1MmWUlfCRc4AMP6lbBP.woff2';
import RobotoBoldCyrillic from '../assets/fonts/KFOlCnqEu92Fr1MmWUlfABc4AMP6lbBP.woff2';
import RobotoBoldGreekExt from '../assets/fonts/KFOlCnqEu92Fr1MmWUlfCBc4AMP6lbBP.woff2';
import RobotoBoldGreek from '../assets/fonts/KFOlCnqEu92Fr1MmWUlfBxc4AMP6lbBP.woff2';
import RobotoBoldVietnamese from '../assets/fonts/KFOlCnqEu92Fr1MmWUlfCxc4AMP6lbBP.woff2';
import RobotoBoldLatinExt from '../assets/fonts/KFOlCnqEu92Fr1MmWUlfChc4AMP6lbBP.woff2';
import RobotoBoldLatin from '../assets/fonts/KFOlCnqEu92Fr1MmWUlfBBc4AMP6lQ.woff2';

// Original CSS https://fonts.googleapis.com/css?family=Roboto:300,400,500,700
export const fonts = css`
	/*


	Roboto Light


	*/
	/* cyrillic-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: url(${RobotoLightCyrillicExt}) format('woff2');
		unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
			U+FE2E-FE2F;
	}
	/* cyrillic */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: url(${RobotoLightCyrillic}) format('woff2');
		unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
	}
	/* greek-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: url(${RobotoLightGreekExt}) format('woff2');
		unicode-range: U+1F00-1FFF;
	}
	/* greek */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: url(${RobotoLightGreek}) format('woff2');
		unicode-range: U+0370-03FF;
	}
	/* vietnamese */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: url(${RobotoLightVietnamese}) format('woff2');
		unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
	}
	/* latin-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: url(${RobotoLightLatinExt}) format('woff2');
		unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
			U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}
	/* latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: url(${RobotoLightLatin}) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
			U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
			U+2215, U+FEFF, U+FFFD;
	}
	/*


	Roboto Regular


	*/
	/* cyrillic-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: url(${RobotoRegularCyrillicExt}) format('woff2');
		unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
			U+FE2E-FE2F;
	}
	/* cyrillic */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: url(${RobotoRegularCyrillic}) format('woff2');
		unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
	}
	/* greek-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: url(${RobotoRegularGreekExt}) format('woff2');
		unicode-range: U+1F00-1FFF;
	}
	/* greek */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: url(${RobotoRegularGreek}) format('woff2');
		unicode-range: U+0370-03FF;
	}
	/* vietnamese */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: url(${RobotoRegularVietnamese}) format('woff2');
		unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
	}
	/* latin-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: url(${RobotoRegularLatinExt}) format('woff2');
		unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
			U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}
	/* latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: url(${RobotoRegularLatin}) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
			U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
			U+2215, U+FEFF, U+FFFD;
	}
	/*


	Roboto Medium


	*/
	/* cyrillic-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: url(${RobotoMediumCyrillicExt}) format('woff2');
		unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
			U+FE2E-FE2F;
	}
	/* cyrillic */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: local('Roboto Medium'), local('Roboto-Medium'),
			url(${RobotoMediumCyrillic}) format('woff2');
		unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
	}
	/* greek-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: url(${RobotoMediumGreekExt}) format('woff2');
		unicode-range: U+1F00-1FFF;
	}
	/* greek */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: url(${RobotoMediumGreek}) format('woff2');
		unicode-range: U+0370-03FF;
	}
	/* vietnamese */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: url(${RobotoMediumVietnamese}) format('woff2');
		unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
	}
	/* latin-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: url(${RobotoMediumLatinExt}) format('woff2');
		unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
			U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}
	/* latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: url(${RobotoMediumLatin}) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
			U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
			U+2215, U+FEFF, U+FFFD;
	}
	/*


	Roboto Bold


	*/
	/* cyrillic-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: url(${RobotoBoldCyrillicExt}) format('woff2');
		unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
			U+FE2E-FE2F;
	}
	/* cyrillic */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: url(${RobotoBoldCyrillic}) format('woff2');
		unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
	}
	/* greek-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: url(${RobotoBoldGreekExt}) format('woff2');
		unicode-range: U+1F00-1FFF;
	}
	/* greek */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: url(${RobotoBoldGreek}) format('woff2');
		unicode-range: U+0370-03FF;
	}
	/* vietnamese */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: url(${RobotoBoldVietnamese}) format('woff2');
		unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
	}
	/* latin-ext */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: url(${RobotoBoldLatinExt}) format('woff2');
		unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
			U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}
	/* latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: url(${RobotoBoldLatin}) format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
			U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
			U+2215, U+FEFF, U+FFFD;
	}
`;
